import React from "react";
import ItemsDetail from "../ItemsDetail";
import AddonsSection from "./AddonsSection";
import SpecialInstructions from "./SpecialInstructions";
import CartActionsSection from "./CartActionsSection";
import RecommendedItems from "../RecommendedItems";

const ProductInfoSection = ({
  id,
  isLoading,
  singleProduct,
  // existingCartItem,
  selectedItem,
  setSelectedItem,
  addonLabels,
  darkMode,
  addToCart,
  loading,
  recommendedProducts,
}) => {
  return (
    <>
      <ItemsDetail
        id={id}
        data={singleProduct?.variants}
        currency={singleProduct?.currency}
        // existingCartItem={existingCartItem}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />

      {addonLabels?.length > 0 && (
        <AddonsSection
          addonLabels={addonLabels}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          darkMode={darkMode}
          currency={singleProduct?.currency}
        />
      )}

      <SpecialInstructions
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        darkMode={darkMode}
      />

      <CartActionsSection
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        darkMode={darkMode}
        addToCart={addToCart}
        loading={loading}
        color={singleProduct?.color}
      />

      {recommendedProducts?.length > 0 && (
        <RecommendedItems data={recommendedProducts} />
      )}
    </>
  );
};

export default ProductInfoSection;
